import Icon from '@ant-design/icons';

import { ReactComponent as UpgradeIcon } from './svgs/upgrade.svg';

const Upgrade = props => {
  return <Icon component={UpgradeIcon} {...props} />;
};

export default Upgrade;
